"use client"

import styled from "@emotion/styled"
import { Box, Typography } from "@mui/material"
import { useTranslations } from "next-intl"
import Image from "next/image"
import { Desktop, Mobile } from "ui"
import { sharedColors } from "ui/theme/colors"
import { mediaQueries } from "ui/theme/mediaQueries"

// MUI's sr-only style
const visuallyHidden = {
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
}

const StyledRoot = styled(Box)`
  min-height: 100vh;
  width: 100vw;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: ${sharedColors.white};
  overflow: hidden;
  ${({ theme }) => theme.breakpoints.down("sm")} {
    min-height: 0;
    aspect-ratio: 360/552;
  }
`

const StyledContent = styled(Box)`
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 64px 32px;
  text-align: center;
  color: ${sharedColors.black};
  ${mediaQueries.mobile} {
    padding: 32px 16px;
  }
`
// TODO: replace the image wiith text to an image without text and show the text in the content
const MaintenancePage = () => {
  const t = useTranslations()
  const pageTitle = t("MaintenancePage.title")
  const pageSubtitle = t("MaintenancePage.subtitle")
  const imageAltText = `${pageTitle} - ${pageSubtitle}`

  return (
    <StyledRoot role="main">
      {/* Desktop Image */}
      <Desktop>
        <Image
          src="/images/maintenance-desktop.svg"
          alt={imageAltText}
          fill
          priority
          style={{ objectFit: "cover" }}
          sizes="100vw"
        />
      </Desktop>
      {/* Mobile Image */}
      <Mobile>
        <Image
          src="/images/maintenance-mobile.svg"
          alt={imageAltText}
          fill
          priority
          style={{ objectFit: "contain" }}
          sizes="100vw"
        />
      </Mobile>
      <StyledContent>
        {/* Visually hidden text for SEO and screen readers */}
        <Typography variant="h1" component="h1" sx={visuallyHidden}>
          {pageTitle}
        </Typography>
        <Typography variant="body1" component="p" sx={visuallyHidden}>
          {pageSubtitle}
        </Typography>
      </StyledContent>
    </StyledRoot>
  )
}

export default MaintenancePage
